import React from 'react';
import { useTheme } from '@mui/material/styles';
// Walk Icon
export const WalkIcon = ({ color, size = 30, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.steps;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width="30" height="30" rx="10" fill={finalColor} />
            <path
                d="M22.0913 9.93264C20.4553 7.69247 18.8448 6.87891 18.3827 7.01432C17.9206 7.14869 17.8271 8.30027 16.9135 9.26395C16.0009 10.2276 14.605 10.7252 14.605 10.7252C14.605 10.7252 14.3691 10.0565 13.6138 9.6828C12.8585 9.30909 12.4261 9.30804 12.0936 9.42456C11.7611 9.54214 11.8981 10.9939 11.8981 11.2847C11.8981 11.375 11.8025 11.9198 11.6676 12.6326H13.5671C13.7636 12.6326 13.924 12.7901 13.924 12.9853C13.924 13.1806 13.7647 13.3381 13.5671 13.3381H11.5316C11.5061 13.4672 11.4806 13.5994 11.4541 13.7317H13.2739C13.4704 13.7317 13.6308 13.8892 13.6308 14.0844C13.6308 14.2786 13.4715 14.4371 13.2739 14.4371H11.3128C11.2852 14.5705 11.2586 14.7017 11.232 14.8308H12.9807C13.1772 14.8308 13.3376 14.9883 13.3376 15.1835C13.3376 15.3788 13.1783 15.5362 12.9807 15.5362H11.0833C11.0536 15.6759 11.0238 15.8081 10.9973 15.9299H12.6875C12.884 15.9299 13.0444 16.0874 13.0444 16.2826C13.0444 16.4779 12.8851 16.6353 12.6875 16.6353H10.8262C10.8103 16.6899 10.7975 16.7267 10.789 16.7393C10.6626 16.9261 10.0996 18.3338 8.58043 19.0561C7.38636 19.624 6 19.1589 6 20.7966C6 22.1329 7.23976 23 9.02874 23C10.2249 23 10.5532 22.9948 10.5532 22.9948C13.617 22.9948 16.0923 20.5898 17.4149 19.3668C18.7375 18.1438 23.0134 13.8367 23.4108 13.442C25.0786 11.7834 22.7425 10.8207 22.0945 9.93264H22.0913Z"
                fill="white"
            />
        </svg>
    );
};

// Didim Icon
export const DidimIcon = ({ color, size = 30, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.didim;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width="30" height="30" rx="10" fill={finalColor} />
            <path
                d="M7.00529 18.4843C7.11178 17.7859 7.78626 17.3004 8.51399 17.4026L11.8509 17.8711L13.5903 15.137C13.6436 14.5323 13.7767 13.1525 14.0341 11.9005C14.1051 11.5683 14.1938 11.2447 14.2826 10.9295L13.2708 11.1936L12.552 13.2973C12.3213 13.9702 11.5669 14.3364 10.8747 14.115C10.1736 13.8935 9.79195 13.1696 10.0227 12.5052L10.9634 9.74564C11.1054 9.33682 11.4515 9.02168 11.8864 8.91096L15.4097 7.99961C14.5399 7.5482 13.9453 6.67944 13.9453 5.66589C13.9453 4.19241 15.1878 3 16.7231 3C18.2585 3 19.5009 4.19241 19.5009 5.66589C19.5009 6.92644 18.5868 7.97406 17.371 8.25513C17.371 8.25513 17.3799 8.27216 17.3887 8.27216C17.4154 8.30623 17.442 8.33178 17.4686 8.36585C17.4952 8.39992 17.513 8.44251 17.5396 8.47658C17.5573 8.51065 17.584 8.54472 17.6017 8.5873C17.6195 8.62989 17.6283 8.67247 17.6461 8.71506C17.655 8.74913 17.6727 8.77468 17.6816 8.80875L18.3561 11.8409L20.8587 12.1901C21.5865 12.2923 22.0923 12.9396 21.9858 13.638C21.8882 14.2768 21.3202 14.7367 20.6724 14.7367C20.6103 14.7367 20.5481 14.7367 20.4771 14.7197L17.0604 14.2427C16.8119 14.2087 16.5989 14.1065 16.4125 13.9617C16.3504 14.4557 16.306 14.8815 16.2794 15.1796L18.7111 18.5439C18.8531 18.7398 18.9329 18.9783 18.9507 19.2168L19.1548 23.6628C19.1903 24.3697 18.6223 24.9659 17.8857 25C17.868 25 17.8413 25 17.8236 25C17.1136 25 16.5279 24.4634 16.4924 23.782L16.306 19.7023L14.9837 17.8796L13.6791 19.9322C13.404 20.3666 12.8892 20.6051 12.3479 20.5285L8.14125 19.9408C7.41352 19.8386 6.90766 19.1912 7.01416 18.4928L7.00529 18.4843Z"
                fill="white"
            />
            <rect x="14" y="25" width="7" height="1" rx="0.5" fill="white" />
        </svg>);
};

// Calory Icon
export const CaloryIcon = ({ color, size = 30, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.calorieRed;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width="30" height="30" rx="10" fill={finalColor} />
            <path
                d="M21.016 9.33088C19.3762 10.3228 18.6002 12.0062 18.3167 13.8085C18.256 8.24118 15.7052 8.31103 14.9966 5C11.4471 7.40294 11.0489 11.2099 11.1974 13.075C10.4956 12.1949 10.2661 10.8886 10.0974 8.78603C8.61282 9.71507 7 12.111 7 15.904C7 19.6971 9.4496 22.8614 12.7832 23.8533C11.6293 23.2945 10.8667 22.2188 10.8667 20.5842C10.8667 17.0566 13.4715 17.35 14.558 13.2846C16.3463 15.0658 16.6634 17.5316 15.8199 20.0044C16.4137 19.4246 16.7647 19.0614 17.1561 17.7132C17.8106 18.4816 18.8431 19.3129 18.8431 20.5493C18.8431 22.1978 17.9996 23.4482 16.6567 24C20.2805 23.2107 23 19.8857 23 15.904C23 12.1739 21.0295 12.2577 21.0295 9.33088H21.016Z"
                fill="white"
            />
        </svg>
    );
};

// Time Icon
export const TimeIcon = ({ color, size = 30, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.time;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width="30" height="30" rx="10" fill={finalColor} />
            <path
                d="M23.49 15C23.49 19.6921 19.682 23.5 14.99 23.5C10.2979 23.5 6.5 19.682 6.5 15C6.5 10.318 10.3079 6.5 15 6.5C19.6921 6.5 23.5 10.3079 23.5 15H23.49ZM18.2754 17.0597L16.3061 15.0904C16.3061 15.0904 16.3262 15.0301 16.3262 14.99C16.3262 14.5278 16.0751 14.146 15.7234 13.9149V9.96631C15.7234 9.57447 15.4019 9.24291 15 9.24291C14.5981 9.24291 14.2766 9.56442 14.2766 9.96631V13.935C13.935 14.1761 13.6939 14.5479 13.6939 15C13.6939 15.7234 14.2866 16.3162 15.01 16.3162C15.0402 16.3162 15.0603 16.3061 15.0904 16.2961L17.0697 18.2754C17.4013 18.607 17.9439 18.607 18.2754 18.2754C18.607 17.9439 18.607 17.4013 18.2754 17.0697V17.0597Z"
                fill="white"
            />
        </svg>
    );
};

// Heart Icon
export const HeartIcon = ({ color, size = 30, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.heartRate;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width="30" height="30" rx="10" fill={finalColor} />
            <path
                d="M13.8028 22.5303L7.67266 16.7243C5.70799 14.8635 5.39629 11.8576 7.15315 9.83577C9.17449 7.51872 12.811 7.39348 15.0024 9.46898C17.1937 7.39348 20.8208 7.51872 22.8421 9.83577C24.6084 11.8576 24.2873 14.8635 22.3321 16.7243L16.2019 22.5303C15.5408 23.1566 14.464 23.1566 13.8028 22.5303Z"
                fill="white"
            />
        </svg>
    );
};

// 모든 활동 아이콘을 하나의 객체로 export
export const ActivityIcons = {
    WalkIcon,
    DidimIcon,
    CaloryIcon,
    TimeIcon,
    HeartIcon,
};

export default ActivityIcons;
